/*
  *+------------------------------------------------------------------------+
  *| Licensed Materials - Property of IBM
  *| IBM Cognos Products: Content Explorer
  *| (C) Copyright IBM Corp. 2020
  *|
  *| US Government Users Restricted Rights - Use, duplication or disclosure
  *| restricted by GSA ADP Schedule Contract with IBM Corp.
  *+------------------------------------------------------------------------+
  */

define([], function() {

	/**
	 * @class
	 * @hideconstructor
	 * @classdesc provides the core dashboard service to be used in glass customaization inside glass
	 */
	class DashboardStartupService {

		/**
		 * sets the dashbard core service which is available synchronously
		 * waits for the DashboardUserProfile to be initialized
		 * Important: initializing the UserProfileService cannot be expensive as this service is set as immediate
		 * @param {Object} glassContext - glass context
		 * @returns {Promise} resolved when the dashboard core service is set
		 */
		initialize(glassContext) {
			return glassContext.getSvc('.DashboardUserProfileService').then((userProfileService) => {
				const coreService = {
					getFeature: (featureName) => {
						let feature;
						if (featureName === 'UserProfile') {
							feature = userProfileService;
						} else {
							throw new Error(`Unknown feature: ${featureName}`);
						}
						return feature;
					}
				};
				glassContext.registerCoreService('.DashboardCoreService', coreService);
			});
		}
	}

	return DashboardStartupService;
});
